import { Button, Tooltip } from 'antd';
import { useState } from 'react';

import { PhoneOutlined } from '@ant-design/icons';
import CallModal from './CallModal';
import { isNowOpen } from '../utils/getWorkingHours';

export default function ButtonRdv(props: { type: "primary" | "default" | "dashed" | "link" | "text" }) {
    const [callModalOpen, setCallModalOpen] = useState(false);

    return (
        <>
            <CallModal open={callModalOpen} onClose={() => setCallModalOpen(false)} />
            <Tooltip title={isNowOpen() ? "Actuellement ouvert" : "Actuellement fermé"}>
                <Button type={props.type} icon={<PhoneOutlined />} onClick={() => setCallModalOpen(true)}>
                    Prendre un rendez-vous
                </Button>
            </Tooltip>
        </>
    )
}
